<template>
  <div v-loading="isLoading">
    <div class="m-b-20 m-r-10 fr">
      <el-button
        class="m-r-10"
        :type="primary"
        @click="reloadIframe()">
        刷新
      </el-button>
      <el-button
        class="m-r-10"
        :type="primary"
        v-if='canOpen'
        @click="newOpenIframe()">
        新窗口打开
      </el-button>
    </div>
    <div class="m-b-20 m-r-10 fl msg">{{msg}}</div>
    <div id='iframeContent'></div>
  </div>
</template>

<style scoped>
.top-title {
  top: 0px;
  left: 0px;
  width: 100%
}
.msg{
  height: 36px;
  line-height: 36px;
}
</style>

<script>
  import http from '../../../assets/js/http'
  export default {
    name: 'iframe',
    props: {
      contentId: {
        type: Number,
        default() {
          return 0
        }
      },
      dealId: {
        type: Number,
        default() {
          return 0
        }
      },
      dataId: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        canOpen: 1,
        url: '',
        msg: '',
        editors: [],
        isLoading: false
      }
    },
    created() {
      this.getCaseDetail()
    },
    methods: {
      reloadIframe() {
        document.getElementById('iframe').src = this.url
      },
      newOpenIframe() {
        window.open(this.url, '_blank')
      },
      createIframe() {
        this.isLoading = true
        let iframe = document.createElement('iframe')
        iframe.style.width = '100%'
        iframe.style.minHeight = '1000px'
        iframe.style.border = 'none'
        iframe.id = 'iframe'
        iframe.src = this.url
        document.getElementById('iframeContent').appendChild(iframe)
        iframe.onload = iframe.onreadystatechange = () => {
          if (this.readyState && this.readyState != 'complete') {
            this.isLoading = true
          } else {
            this.isLoading = false
          }
        }
      },
      getCaseDetail() { // 获取iframe数据
        this.isLoading = true
        let postData = ''
        if (this.dataId) {
          postData = {
            params: {
              id: this.dataId
            }
          }
        }
        let url = `cms/contents/${this.contentId}/iframe/${this.dealId}`
        this.apiGet(url, postData).then((res) => {
          this.isLoading = false
          if (res.code == 200) {
            this.canOpen = res.data.canOpen
            this.url = res.data.url
            this.msg = res.data.msg
            if (this.url) {
              this.createIframe()
            } else {
              _g.toastMsg(this, 'warning', 'iframe的url为空，无法打开')
            }
          } else {
            setTimeout(() => {
              this.goback()
            }, 1000)
            _g.dealError(this, res)
          }
        })
      },
      goback() {
        router.go(-1)
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// iframeRender.vue?756f570e